// extracted by mini-css-extract-plugin
module.exports = {"HeaderMobile":"header-mobile_HeaderMobile__ApC6L"};